<!-- 证券从业考试 -->
<template>
  <div class="el-CoachExamList">
    <el-row class="content_block mb30">
      <TitleInfo title="从业考证" :titleImg="kaoshi"></TitleInfo>
      <template v-if="myAppsList.length > 0">
        <el-row class="pt20 pl20 coachExamList_list">
          <ul>
            <template v-for="(item, index) in myAppsList" >
              <li :key="index">
                <el-image class="thirdParty_img c_p mr20" :src="js2"></el-image>
                <el-row>
                  <p class="limit_line_one fontB" style="margin: 0 0 6px 0;">{{item.generalQuestionSettingName}}</p>
                  <p class="limit_line_one" style="margin: 0 0 6px 0;">题{{$chineseNum(index)}} <span style="color: #409eff;">（ 共 {{item.questionTotalCount}} 题 ）</span></p>
                  <!-- <p class="limit_line_one" style="margin: 0 0 6px 0;">题目数量：{{item.questionTotalCount}}</p> -->
                  <p class="limit_line_one" style="margin: 0 0 6px 0;color: #969494">
                    开始时间：{{$timeFormat(item.generalQuestionStartTime,'yyyy-MM-dd HH:mm')}}
                  </p>
                  <p class="limit_line_one" style="margin: 0 0 6px 0;color: #969494;">
                    结束时间：{{$timeFormat(item.generalQuestionEndTime,'yyyy-MM-dd HH:mm')}}
                  </p>
                  <div style="float: right;width: calc(100% - 220px);margin-top: 6px;">
                    <span class="but_icon" style="font-size: 19px;line-height: 55px;color: #F83131;">
                      {{item.myScore || '-'}} 分
                    </span>
                    <span class="but_icon">
                      <i class="el-icon-video-play c_p" style="font-size: 20px;color: #06BFCF;" @click="startExam(item)"></i>
                      <br>
                      <el-link style="margin-top: 5px;" :underline="false" @click="startExam(item)">开始考试</el-link>
                    </span>
                    <span class="but_icon">
                      <i class="el-icon-document c_p" style="font-size: 20px;color: #FF6554;" @click="resultDetails(item)"></i>
                      <br>
                      <el-link style="margin-top: 5px;" :underline="false" @click="resultDetails(item)">成绩详情</el-link>
                    </span>
                  </div>
                </el-row>
              </li>
            </template>
          </ul>
        </el-row>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="page"
          :page-sizes="[6, 12, 20, 40]"
          :page-size="limit"
          background
          class="m20 t_r"
          :hide-on-single-page="true"
          layout="sizes, prev, pager, next,jumper"
          :total="total">
        </el-pagination>
      </template>
      <el-empty v-else description=""></el-empty>
    </el-row>
  </div>
</template>

<script>
import TitleInfo from "@/components/TitleInfo"; //页面头部
export default {
  name: "CoachExamList",
  components: {
  	TitleInfo,
  },
  data() {
    return {
      courseId:this.$route.query.courseId,
      courseInfoName:this.$route.query.courseInfoName,
      kaoshi:require("../../images/coach/kaoshi@2x.png"),
      js2:require("../../images/course/js2.png"),
      myAppsList:[],
      total: 0,
      limit:6,
      page:1,
      nowTime:null,
      timeIn:null
    };
  },
  created() {
    this.getNowTime();
    this.getInfo();
  },
  mounted() {
    //this.addSystem();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.limit = val;
      this.getInfo();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getInfo();
    },
    getInfo(){
      let param = {
        limit:this.limit,
        page:this.page,
        businessId:this.courseId,
        businessType:"FROM_SYSTEM",
        generalQuestionSettingPushStatus:"PUSH",
        generalQuestionSettingType: "EXAM",
      }
      this.$post("/api/generalQuestionSetting/getPageList.do",param).then((ret) =>{
        if(ret.code == 0){
          this.total = Number(ret.count);
          this.myAppsList = ret.data;
          if(!this.$isEmpty(this.myAppsList)){
            for(let i = 0;i< this.myAppsList.length;i++){
              for(let o = 0;o< this.myAppsList[i].questionSettingOptions.length;o++){
                this.myAppsList[i].questionTotalCount = Number(this.myAppsList[i].questionTotalCount || 0) + Number(this.myAppsList[i].questionSettingOptions[o].selectCount);
              }
            }
          }
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    startExam(item){ //考试考试
      if(this.$compareTime(item.generalQuestionStartTime,this.nowTime) && this.$compareTime(this.nowTime,item.generalQuestionEndTime)){
        this.$router.push({name:'CoachExam',query:{generalQuestionSettingId:item.generalQuestionSettingId,courseInfoName:this.courseInfoName}});
      }else{
         this.$message.warning("答题时间还未到或已结束！");
      }
    },
    resultDetails(item){ //详情
      this.$router.push({name:'CoachExamDetails',query:{generalQuestionSettingId:item.generalQuestionSettingId,courseInfoName:this.courseInfoName}});
    },
    getNowTime(){ //获取当前时间
      this.$get("/getNowTime.json").then((ret) =>{
        this.nowTime = ret.data;
      });
    },
    addSystem(){ //模块使用统计
      //模块使用时间 开始
      const timeNum = this.$ls.get('timeNum'); //获取统一
      this.timeIn = setInterval(()=>{
        let param = {
          firstName:"考证辅导",//一级名称
          secondName:this.courseInfoName,//二级名称
          useDuration:timeNum / 1000 / 60//单次使用时长（单位：分钟）
        }
        this.$addSystemUseLog(param);
      },timeNum);
      // 结束
    }
  },
  beforeDestroy() {
    clearInterval(this.timeIn); //关闭定时
  }
};
</script>
 <style  lang="less">
  .el-CoachExamList{
    padding: 20px 20px 0;
    .coachExamList_list{
      min-height: 320px;overflow: auto;
      ul{
        list-style-type:none;
        margin: 0;
        padding: 0;
      }
      li{
        float: left;
        width: calc(33.3% - 65px);
        padding: 20px;
        margin: 0 20px 20px 0;
        border: 1px solid #E1E1E1;
        font-size: 14px;
      }
      .but_icon{
        width: 33%;height: 55px;float: left;text-align: center;
      }
    }

    .content_block{
      background-color: #ffffff;
      .el-divider--horizontal{
        margin: 0;
      }
    }
    .thirdParty_img{
      width: 200px;
      height: 148px;
      float: left;
    }
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/pages/certificate/CoachExamList.vue